var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editable)?_c('div',[_c('span',[_vm._v("Portal zone: "+_vm._s(_vm.to))]),_c('ScPlaceholder',{attrs:{"name":"jss-portal","rendering":_vm.rendering}})],1):_c('div',[_c('portal',{attrs:{"to":_vm.to}},[_vm._t("default"),_c('ScPlaceholder',{attrs:{"name":"jss-portal","rendering":_vm.rendering}})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }